import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

interface AcceptEulaTcResponse {
  acceptEulaTC: {
    status_code: number;
    body: {
      data: unknown;
      message: string;
      success: boolean;
    };
  };
}

export const ACCEPT_EULA_TC = gql`
  mutation acceptEulaTC {
    acceptEulaTC {
      status_code
      body {
        message
        data
      }
    }
  }
`;

export const useAcceptEulaTC = (
  options?: MutationHookOptions<AcceptEulaTcResponse, OperationVariables>,
) => {
  return useMutation(ACCEPT_EULA_TC, options);
};
